import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import {
  ASSISTANT_CATALOG_BUTTON_COLOR,
  ASSISTANT_CATALOG_BUTTON_TEXT,
} from '@/lib/assistant/assistantWelcomeMessage';

export function AssistantMessageOptionButtons({ options, testIdPrefix = 'option', primaryColor }) {
  if (!options?.length) return null;

  return (
    <div className="grid grid-cols-1 gap-2">
      {options.map((option, optIndex) => {
        const Icon = option.icon;
        const variant = option.variant || 'default';
        const isMustard = variant === 'mustard';
        const isEmphasis = variant === 'emphasis';
        const isOutline = variant === 'outline' || (!isMustard && !isEmphasis);

        return (
          <Button
            key={`${testIdPrefix}-${option.value ?? optIndex}`}
            variant={isMustard || isEmphasis ? 'default' : 'outline'}
            className={cn(
              'w-full justify-start h-auto py-3 text-left font-medium',
              isEmphasis && 'border-2',
              isOutline && 'text-foreground border-border bg-background',
            )}
            style={
              isMustard
                ? {
                    backgroundColor: ASSISTANT_CATALOG_BUTTON_COLOR,
                    color: ASSISTANT_CATALOG_BUTTON_TEXT,
                    borderColor: ASSISTANT_CATALOG_BUTTON_COLOR,
                  }
                : isEmphasis
                  ? {
                      backgroundColor: primaryColor || '#18181B',
                      color: '#fff',
                      borderColor: primaryColor || '#18181B',
                    }
                  : undefined
            }
            onClick={option.action}
            data-testid={`${testIdPrefix}-${option.value}`}
          >
            {Icon ? (
              <Icon
                className={cn('w-4 h-4 mr-2 flex-shrink-0', isMustard && 'text-[#111]')}
              />
            ) : null}
            <span className="flex-1 leading-snug">{option.label}</span>
          </Button>
        );
      })}
    </div>
  );
}
